import {
  Chip,
  EmptyState,
  FeaturedIcon,
  Icon,
  Pagination,
  Select,
  Sidebar,
  Skeleton,
  TextArea,
  TextLabel,
  Tooltip,
  TopBar,
} from '@saleswhale/barnacle/components/';
import { ButtonGroup } from '@saleswhale/barnacle/components/buttons';
import Badge from '@saleswhale/barnacle/components/data-display/Badge';
import { DonutChart } from '@saleswhale/barnacle/components/data-display/charts';
import DatePicker from '@saleswhale/barnacle/components/data-entry/DatePicker';
import TimePicker from '@saleswhale/barnacle/components/data-entry/TimePicker';
import Dropdown from '@saleswhale/barnacle/components/Dropdown';
import Popover from '@saleswhale/barnacle/components/Popover';

const Chip6DS = Chip;
const DatePicker6DS = DatePicker;
const Dropdown6DS = Dropdown;
const DonutChart6DS = DonutChart;
const EmptyState6DS = EmptyState;
const FeaturedIcon6DS = FeaturedIcon;
const Icon6DS = Icon;
const Pagination6DS = Pagination;
const Select6DS = Select;
const Sidebar6DS = Sidebar;
const Skeleton6DS = Skeleton;
const TextArea6DS = TextArea;
const Tooltip6DS = Tooltip;
const TopBar6DS = TopBar;
const ButtonGroup6DS = ButtonGroup;
const TextLabel6DS = TextLabel;
const Badge6DS = Badge;
const TimePicker6DS = TimePicker;
const Popover6DS = Popover;

export {
  Chip6DS,
  DatePicker6DS,
  Dropdown6DS,
  DonutChart6DS,
  EmptyState6DS,
  FeaturedIcon6DS,
  Icon6DS,
  Pagination6DS,
  Select6DS,
  Sidebar6DS,
  Skeleton6DS,
  TextArea6DS,
  TextLabel6DS,
  Tooltip6DS,
  TopBar6DS,
  ButtonGroup6DS,
  Badge6DS,
  TimePicker6DS,
  Popover6DS,
};
